import { DynamicField } from "./dynamic-field.model";

export class DynamicCheckbox<T> extends DynamicField<T> {

    group?: string;
    binary?: boolean;

    constructor(source: Partial<DynamicCheckbox<T>>) {
        super();
        this.binary = true;
        Object.assign(this, source);

    }
}